export default __webpack_public_path__ + "img/EF.663ae4f1cb3a6331e89e74cd25549ee7.jpg";